<div class="header-top d-none d-print-flex">
  <div class="header-top-content">
    <img [src]="headerLogo" alt="Logo" />
  </div>
</div>

@let customerNameValue = customerName();
@let portfolioIdValue = portfolioId();
@let buildingsWithPlanValue = buildingsWithPlan();
@let portfolioBuildingsRoadmapValue = portfolioBuildingsRoadmap();
@let buildingsForAppendicesValue = buildingsForAppendices();
@let yearsValue = years();
@if (
  portfolioIdValue &&
  buildingsWithPlanValue &&
  portfolioBuildingsRoadmapValue &&
  buildingsForAppendicesValue &&
  yearsValue
) {
  <div class="container">
    <cfp-report-cover-page
      [portfolioId]="portfolioIdValue"
      [logo]="coverLogo"
      [reportTitle]="'portfolioBuildingsRoadmapReport.title' | translate"
      [organizationName]="customerNameValue"
      [coverPageClasses]="'portfolio-buildings-roadmap-report-cover-page'"
      [showPoweredBy]="false"
      [showAsScreenPage]="true"
      [enforcePdfRoute]="false"
    >
      <ng-container cover-footer *ngTemplateOutlet="footerTemplate" />
    </cfp-report-cover-page>
  </div>

  <cfp-printable-content [dataLoaded]="!!portfolioBuildingsRoadmap()">
    <div body class="container">
      @if (showIntroductionPage) {
        <cfp-report-page [portfolioTitle]="customerNameValue" [headerLogo]="headerLogo" [chromeFooter]="footerTemplate">
          <div [innerHtml]="'portfolioBuildingsRoadmapReport.page.intro' | translate"></div>
        </cfp-report-page>
      }
      @let portfolioNotesValue = portfolioNotes();
      @if (portfolioNotesValue && portfolioNotesValue.length > 0) {
        <cfp-report-page
          [portfolioTitle]="customerName()"
          [headerLogo]="headerLogo"
          [chromeFooter]="footerTemplate"
        >
          <cfp-notes-list [notes]="portfolioNotesValue" />
        </cfp-report-page>
      }
      <cfp-report-buildings-pages
        [portfolioId]="portfolioIdValue"
        [customerName]="customerNameValue"
        [portfolioBuildingsRoadmap]="portfolioBuildingsRoadmapValue"
        [headerLogo]="headerLogo"
        [chromeFooter]="footerTemplate"
      />
      <cfp-report-energy-labels-pages
        [portfolioId]="portfolioIdValue"
        [customerName]="customerNameValue"
        [buildingsWithPlan]="buildingsWithPlanValue"
        [portfolioBuildingsRoadmap]="portfolioBuildingsRoadmapValue"
        [hasBuildingsWithNoPlan]="buildingsWithPlanValue.length < portfolioBuildingsRoadmapValue.buildings.length"
        [years]="yearsValue"
        [headerLogo]="headerLogo"
        [chromeFooter]="footerTemplate"
      />
      <cfp-report-investment-pages
        [customerName]="customerNameValue"
        [buildingsWithPlan]="buildingsWithPlanValue"
        [portfolioBuildingsRoadmap]="portfolioBuildingsRoadmapValue"
        [years]="yearsValue"
        [headerLogo]="headerLogo"
        [chromeFooter]="footerTemplate"
      />
      <cfp-report-appendices-pages
        [customerName]="customerNameValue"
        [buildings]="buildingsForAppendicesValue"
        [portfolioBuildingsRoadmap]="portfolioBuildingsRoadmapValue"
        [headerLogo]="headerLogo"
        [chromeFooter]="footerTemplate"
      />

      @if (showExplanationPage) {
        <cfp-report-page
          [portfolioTitle]="customerNameValue"
          [headerLogo]="headerLogo"
          [chromeFooter]="footerTemplate"
          class="d-none d-print-block"
        >
          <div class="report-explanation-page">
            <h2 class="mb-4">{{ 'report.explanationField' | translate }}</h2>
            <div class="report-explanation-field"></div>
          </div>
        </cfp-report-page>
      }

      <cfp-report-page
        [portfolioTitle]="customerNameValue"
        [headerLogo]="headerLogo"
        [chromeFooter]="footerTemplate"
        [lastPage]="true"
      >
        <div [innerHtml]="'portfolioBuildingsRoadmapReport.page.last' | translate"></div>
      </cfp-report-page>
    </div>

    <cfp-report-footer footer [showPoweredBy]="false">
      <ng-container *ngTemplateOutlet="footerTemplate" />
    </cfp-report-footer>
  </cfp-printable-content>
}

<ng-template #footerTemplate>
  <div class="d-flex w-100 justify-content-between">
    <div>{{ 'portfolioBuildingsRoadmapReport.footer.left' | translate: { year: currentDate.getFullYear() } }}</div>
    <div [innerHtml]="'portfolioBuildingsRoadmapReport.footer.right' | translate"></div>
  </div>
</ng-template>
